// extracted by mini-css-extract-plugin
module.exports = {"social":"styles_social__2pyd4","imageLink":"styles_imageLink__bvn_q"};